export const SET_LOGO_POSITION = 'SET_LOGO_POSITION';

export const GET_LOGO_POSITION_START = 'GET_LOGO_POSITION_START';
export const GET_LOGO_POSITION_SUCCESS = 'GET_LOGO_POSITION_SUCCESS';
export const GET_LOGO_POSITION_FAILED = 'GET_LOGO_POSITION_FAILED';

export const UPDATE_LOGO_POSITION_START: string = 'UPDATE_LOGO_POSITION_START';
export const UPDATE_LOGO_POSITION_SUCCESS = 'UPDATE_LOGO_POSITION_SUCCESS';
export const UPDATE_LOGO_POSITION_FAILED = 'UPDATE_LOGO_POSITION_FAILED';
